import { type MutationError, trpc } from '@/shared/api';

interface UseRenameCategoryOptions {
  readonly onSuccess?: () => void;
}

/** 카테고리 이름 수정. */
export const useRenameCategory = ({ onSuccess }: UseRenameCategoryOptions = {}) => {
  const mutation = trpc.productManagement.categories.update.useMutation({ onSuccess });

  const error: MutationError | null = mutation.error;

  return {
    renameCategory: mutation.mutate,
    /** 저장이 진행 중인 카테고리 id — 진행 표시를 해당 행에만 스코프한다. */
    pendingId: mutation.isPending ? (mutation.variables?.id ?? null) : null,
    isPending: mutation.isPending,
    error,
    /** 지난 오류를 지운다 — 같은 오류 줄을 쓰는 다른 요청을 시작할 때 옛 오류가 남지 않게. */
    reset: mutation.reset,
  };
};
